import { render, staticRenderFns } from "./Traslados.vue?vue&type=template&id=49bb2ab0&scoped=true&"
import script from "./Traslados.vue?vue&type=script&lang=js&"
export * from "./Traslados.vue?vue&type=script&lang=js&"
import style0 from "./Traslados.vue?vue&type=style&index=0&id=49bb2ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb2ab0",
  null
  
)

export default component.exports